export default __webpack_public_path__ + "media/images/nearbyPlaces/super_market-d0101608a93e4467ebc0ebbc4a082392.png";